import { render, staticRenderFns } from "./fireFighting.vue?vue&type=template&id=567b6666&scoped=true&"
import script from "./fireFighting.vue?vue&type=script&lang=js&"
export * from "./fireFighting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b6666",
  null
  
)

export default component.exports